// import React, { useCallback, useEffect, useState } from 'react';
// import Avatar from '@mui/material/Avatar';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Checkbox from '@mui/material/Checkbox';
// import Link from '@mui/material/Link';
// import Paper from '@mui/material/Paper';
// import Box from '@mui/material/Box';
// import Grid from '@mui/material/Grid';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
// import Typography from '@mui/material/Typography';
// import { Backdrop, Container, Divider } from '@mui/material';
// import axios from 'axios';
// import { API, Auth, graphqlOperation } from 'aws-amplify';
// import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
// import { showErrorSnackbar, showWarningSnackbar } from '../components/snackBar/snakbar';
// import { useNavigate } from 'react-router-dom';
// import { useDebounce } from '../hooks/useDebounce';
// import CustomInputBox from '../components/customInputBox/CustomInputBox';
// import { Email, Lock, Visibility, VisibilityOff } from '@mui/icons-material';
// import { getCognitoUserSessions } from '../graphql/queries';
// import { loginCognitoUser, logoutCognitoUser } from '../graphql/mutations';
// import { useDispatch } from 'react-redux';
// import { logIn } from '../redux/reducers/login';
// import { LoadingButton } from '@mui/lab';

// export default function LoginForm() {
//     let navigate = useNavigate();
//     const [state, setState] = useState({
//         email: "",
//         Password: "",
//         open: false,
//         errorStatus: {
//             email: false,
//             Password: false,
//         },
//         errorFields: {
//             email: "",
//             Password: "",
//             open: "",
//         },
//     });
//     const [showPassword, setShowPassword] = useState(false);
//     const [BackDrop, setBackDrop] = useState(false)
//     const [submit, setSubmit] = useState(false);
//     const handleForgetPasswordClick = async () => {
//         if (state?.email) {
//             setBackDrop(true)
//             await Auth.forgotPassword(state.email)
//                 .then(data => {
//                     localStorage.setItem('startTime', new Date());
//                     navigate("/newpassword", { state: { email: state.email } });
//                     setState((prev) => ({
//                         ...prev,
//                         open: false,
//                         errorFields: {
//                             ...prev.errorFields,
//                             open: ''
//                         }
//                     }))

//                 })
//                 .catch(error => {
//                     console.log(error)
//                     if (error.name === "LimitExceededException") {
//                         console.log(error.response)
//                         console.log(error.message)
//                         setState((prev) => ({ ...prev, errorStatus: { ...prev.errorStatus, email: true }, errorFields: { ...prev.errorFields, email: error.message } }))
//                     } else {
//                         setState((prev) => ({ ...prev, errorStatus: { ...prev.errorStatus, email: true }, errorFields: { ...prev.errorFields, email: "Email doesn't exist. if you signed up using Google please login with Google button" } }))
//                     }
//                     // showWarningSnackbar("The user either did not sign up with us or used a Google account to sign up")
//                     // navigate("/forgotpassword")
//                 })
//                 .finally(() => {
//                     setBackDrop(false);
//                 })
//         } else {
//             setState((prev) => ({ ...prev, errorStatus: { ...prev.errorStatus, email: true }, errorFields: { ...prev.errorFields, email: "Please enter an email" } }))

//             // navigate("/forgotpassword")
//         }
//     }

//     const initGsi = () => {
//         if (window.google && window.google?.accounts) {
//             window.google.accounts.id.initialize({
//                 client_id:
//                     "849073043661-2124n2t36fpb882mrr647mgllou2kp23.apps.googleusercontent.com",
//                 callback: async (response) => {
//                     console.log(response)
//                     const option = {
//                         method: "POST",
//                         url: "https://j6uoqeebft7cebrfkn4ct6pxom0qxluz.lambda-url.ap-south-1.on.aws/",
//                         data: JSON.stringify({ credential: response.credential }),
//                     };
//                     const responseA = await axios(option)
//                         .catch((err) => {
//                             console.log(err);
//                         })
//                         .finally(() => { });
//                     console.log(responseA)
//                     if (responseA.status == 200 || responseA.status == 201) {
//                         const responses = await Auth.federatedSignIn({
//                             provider: CognitoHostedUIIdentityProvider.Google,
//                         });
//                         console.log(responses)
//                     } else {
//                         console.log(responseA.data.error)
//                         showWarningSnackbar(responseA.data.error)
//                     }

//                 },
//             });
//             window.google.accounts.id.renderButton(
//                 document.getElementById("googleSignInButton"),
//                 { theme: "outline", size: "large" }
//             );
//         }
//     };
//     const createScript = () => {
//         const script = document.createElement("script");
//         script.src = "https://accounts.google.com/gsi/client";
//         script.async = true;
//         script.defer = true;
//         script.onload = initGsi;
//         document.body.appendChild(script);
//     };
//     useEffect(() => {
//         createScript()
//     }, [])
//     useEffect(() => {
//         window.onload = function () {
//             var rememberedUsername = localStorage.getItem("rememberedUsername");

//             if (rememberedUsername) {
//                 document.getElementById("email").value = rememberedUsername;
//                 document.getElementById("checkbox").checked = true;
//             }
//         };
//     }, []);
//     const [loading, setLoading] = useState(false);
//     const [logoutFromAllDevice, setlogoutFromAllDevice] = useState(false);
//     const dispatch = useDispatch();
//     const [reminder, setReminder] = useState(false);

//     const handleEditError = (name, value) => {
//         if (value == "") {
//             setState((prev) => ({
//                 ...prev,
//                 [name]: value,
//                 errorStatus: {
//                     ...prev.errorStatus,
//                     [name]: true,
//                 },
//                 errorFields: {
//                     ...prev.errorFields,
//                     [name]: "Email is Required",
//                 },
//             }));
//         } else if (
//             !/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
//                 value
//             )
//         ) {
//             setState((prev) => ({
//                 ...prev,
//                 [name]: value,
//                 errorStatus: {
//                     ...prev.errorStatus,
//                     [name]: true,
//                 },
//                 errorFields: {
//                     ...prev.errorFields,
//                     [name]: "Invalid Email Address",
//                 },
//             }));
//         }
//     };
//     const debouncedSearch = useCallback(
//         useDebounce(
//             (name, value) => {
//                 handleEditError(name, value);
//             },
//             500,
//             false
//         ),
//         []
//     );
//     const formValidation = (data) => {
//         const regex =
//             /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

//         let isvalid = true;
//         Object.keys(data).map((itemKey) => {
//             if (itemKey === "email") {
//                 if (data[itemKey].trim().length <= 0) {
//                     isvalid = false;
//                     setState((prev) => ({
//                         ...prev,
//                         errorStatus: {
//                             ...prev.errorStatus,
//                             [itemKey]: true,
//                         },
//                         errorFields: {
//                             ...prev.errorFields,
//                             [itemKey]: "Email is required",
//                         },
//                     }));
//                 } else if (!regex.test(data[itemKey])) {
//                     isvalid = false;
//                     setState((prev) => ({
//                         ...prev,
//                         errorStatus: {
//                             ...prev.errorStatus,
//                             [itemKey]: true,
//                         },
//                         errorFields: {
//                             ...prev.errorFields,
//                             [itemKey]: "Invalid email address",
//                         },
//                     }));
//                 } else {
//                     isvalid = true;
//                     setState((prev) => ({
//                         ...prev,
//                         errorStatus: {
//                             ...prev.errorStatus,
//                             [itemKey]: false,
//                         },
//                         errorFields: {
//                             ...prev.errorFields,
//                             [itemKey]: "",
//                         },
//                     }));
//                 }
//             }

//             if (itemKey === "password") {
//                 if (data[itemKey].trim().length <= 0) {
//                     isvalid = false;
//                     setState((prev) => ({
//                         ...prev,
//                         errorStatus: {
//                             ...prev.errorStatus,
//                             [itemKey]: true,
//                         },
//                         errorFields: {
//                             ...prev.errorFields,
//                             [itemKey]: "Password is required",
//                         },
//                     }));
//                 } else if (
//                     data[itemKey].trim().length > 0 &&
//                     data[itemKey].trim().length < 4
//                 ) {
//                     isvalid = false;
//                     setState((prev) => ({
//                         ...prev,
//                         errorStatus: {
//                             ...prev.errorStatus,
//                             [itemKey]: true,
//                         },
//                         errorFields: {
//                             ...prev.errorFields,
//                             [itemKey]: "Please enter atleast 4 digits",
//                         },
//                     }));
//                 } else {
//                     setState((prev) => ({
//                         ...prev,
//                         errorStatus: {
//                             ...prev.errorStatus,
//                             [itemKey]: false,
//                         },
//                         errorFields: {
//                             ...prev.errorFields,
//                             [itemKey]: "",
//                         },
//                     }));
//                 }
//             }
//         });

//         return isvalid;
//     };
//     async function signIn(values) {
//         try {
//             let response = await Auth.signIn(values.email, values.password);
//             setState((prev) => ({
//                 ...prev,
//                 open: false,
//                 errorFields: {
//                     ...prev.errorFields,
//                     open: "",
//                 },
//             }));
//             setLoading(false);

//             let sessions = await API.graphql(
//                 graphqlOperation(getCognitoUserSessions)
//             );
//             if (sessions?.data?.getCognitoUserSessions?.length) {
//                 console.log("too many sessions");
//                 let accessToken = null;
//                 Object.keys(response?.storage).map((key) => {
//                     if (
//                         key.startsWith("CognitoIdentityServiceProvider") &&
//                         key.endsWith(".accessToken")
//                     ) {
//                         accessToken = response.storage[key];
//                     }
//                 });
//                 if (accessToken) setlogoutFromAllDevice(accessToken);
//             } else {
//                 let createSession = await API.graphql(
//                     graphqlOperation(loginCognitoUser)
//                 );
//                 console.log(createSession);
//                 localStorage.setItem(
//                     "sessionID",
//                     createSession.data.loginCognitoUser.SessionID
//                 );
//                 dispatch(logIn());
//                 navigate("/");
//             }

//             // if (accessToken) {
//             //     const option = {
//             //         method: 'POST',
//             //         url: "https://5prqwinddvlbk4yf2pup3dauoy0vsena.lambda-url.ap-south-1.on.aws/",
//             //         headers: { Authorization: accessToken }
//             //     }
//             //     const response = await axios(option);
//             //     console.log(response)
//             // }
//         } catch (error) {
//             console.log(error)

//             if (error.code == "UserNotConfirmedException") {
//                 setState((prev) => ({
//                     ...prev,
//                     // open: true,
//                     errorFields: {
//                         ...prev.errorFields,
//                         open: error.message,
//                     },
//                 }));
//                 if (error?.message?.length) {
//                     showErrorSnackbar(error.message)
//                 } else {
//                     showErrorSnackbar("Network Error")
//                 }
//                 console.log({ values, state })
//                 await Auth.resendSignUp(values.email)
//                 navigate("/confirmsignup", {
//                     state: { email: values.email, password: values.password },
//                 });
//                 console.log(error.code);
//                 console.log(error.message);
//                 setLoading(false);

//             }
//             else if (error.code == "UserNotFoundException") {
//                 axios.post("https://bxucs7zcvsocygyw77ktcxnzvi0xjqsf.lambda-url.ap-south-1.on.aws/", { email: values.email }).then((response) => {
//                     console.log(response)
//                     if (response.request.status === 201) {
//                         showWarningSnackbar(response.data.error)
//                     } else if (response.request.status === 200) {
//                         showWarningSnackbar(response.data.error)
//                     }
//                     setLoading(false);

//                 }).catch((errors) => {
//                     console.log(errors)
//                     setLoading(false);

//                 })
//             }
//             else {
//                 console.log(error.code);
//                 console.log(error.message);
//                 showErrorSnackbar("Network Error")
//                 setState((prev) => ({
//                     ...prev,
//                     open: true,
//                     errorFields: {
//                         ...prev.errorFields,
//                         open: error.message,
//                     },
//                 }));
//                 setLoading(false);

//             }
//         }
//     }
//     const ForceLogoutAndLogin = async () => {
//         setLoading(true);
//         let accessToken = logoutFromAllDevice;
//         if (accessToken) {
//             const option = {
//                 method: "POST",
//                 url: "https://5prqwinddvlbk4yf2pup3dauoy0vsena.lambda-url.ap-south-1.on.aws/",
//                 headers: { Authorization: accessToken },
//             };
//             const response = await axios(option);
//             console.log(response);
//         }
//         let sessions = await API.graphql(graphqlOperation(logoutCognitoUser));
//         const { email, Password } = state;

//         let response = await Auth.signIn(email, Password);
//         setState((prev) => ({
//             ...prev,
//             open: false,
//             errorFields: {
//                 ...prev.errorFields,
//                 open: "",
//             },
//         }));
//         let createSession = await API.graphql(graphqlOperation(loginCognitoUser));
//         console.log(createSession);
//         localStorage.setItem(
//             "sessionID",
//             createSession.data.loginCognitoUser.SessionID
//         );
//         dispatch(logIn());
//         navigate("/");
//         setLoading(false);
//         setlogoutFromAllDevice(false);
//     };
//     const handleSubmit = (event) => {
//         event.preventDefault();
//         setSubmit(true);
//         console.log(event);

//         const { email, Password } = state;

//         const formData = {
//             email: email,
//             password: Password,
//         };

//         if (formValidation(formData)) {
//             setLoading(true);
//             signIn(formData);
//         }

//         if (reminder) {
//             //  To remind the email and password
//         }
//     };
//     return (
//         <Container>
//             <Backdrop open={BackDrop} sx={{ zIndex: 999 }} ></Backdrop>
//             <Grid sx={{ pb: "10px", borderRadius: "8px" }} item xs={12} sm={8} md={12} component={Paper} elevation={6} square>
//                 <Box
//                     sx={{
//                         my: 8,
//                         mx: 4,
//                         display: 'flex',
//                         flexDirection: 'column',
//                         alignItems: 'center',
//                     }}
//                 >
//                     <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
//                         <LockOutlinedIcon />
//                     </Avatar>
//                     <Typography component="h1" variant="h5">
//                         Sign in
//                     </Typography>
//                     <form onSubmit={(e) => { handleSubmit(e) }} component=""
//                         onKeyDown={(e) => {
//                             if (e.key === "Enter") {
//                                 handleSubmit(e);
//                             }
//                         }}
//                         noValidate sx={{ mt: 1 }}>
//                         <Box
//                             sx={{
//                                 textAlign: "center",
//                                 height: "10%",
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 marginTop: "10px",
//                                 alignItems: "center",
//                                 justifyContent: "space-around",
//                             }}
//                         >
//                             <button type="button" id="googleSignInButton" />
//                         </Box>
//                         <Box sx={{ marginBottom: "10px", marginTop: "20px" }}>
//                             <Box sx={{ width: "100%" }}>
//                                 <Divider></Divider>
//                             </Box>
//                             <Box
//                                 sx={{
//                                     // backgroundColor: "#F7F7F7",
//                                     backgroundColor: "#ffff",
//                                     marginTop: "-14px",
//                                     marginLeft: "25%",
//                                     width: "140px",
//                                     textAlign: "center",
//                                 }}
//                             >
//                                 <Typography
//                                     sx={{
//                                         color: "#9F9F9F",
//                                     }}
//                                 >
//                                     or continue with
//                                 </Typography>
//                             </Box>
//                         </Box>
//                         <CustomInputBox
//                             component="input"
//                             name="email"
//                             placeholder="Enter Your Email"
//                             type="email"
//                             autoFocus={true}
//                             autoComplete="on"
//                             onBlur={(e) => {
//                                 const { name, value } = e.target;
//                                 if (value !== "") handleEditError(name, value);
//                             }}
//                             onChange={(e) => {
//                                 const { name, value } = e.target;
//                                 if (submit) {
//                                     debouncedSearch(name, value);
//                                 }
//                                 setState((prev) => ({
//                                     ...prev,
//                                     [name]: value,
//                                     errorStatus: {
//                                         ...prev.errorStatus,
//                                         [name]: false,
//                                     },
//                                     errorFields: {
//                                         ...prev.errorFields,
//                                         [name]: "",
//                                     },
//                                 }));
//                             }}
//                             state={state}
//                             icon={
//                                 <Email
//                                     sx={{
//                                         color:
//                                             state.errorStatus.email === true
//                                                 ? "danger.main"
//                                                 : "#8a8787",
//                                     }}
//                                     className="icon"
//                                 />
//                             }
//                         />
//                         <CustomInputBox
//                             name="Password"
//                             placeholder="Password"
//                             type={showPassword ? "text" : "password"}
//                             autoFocus={false}
//                             autoComplete="on"
//                             onChange={(e) => {
//                                 const { name, value } = e.target;
//                                 if (value == "") {
//                                     setState((prev) => ({
//                                         ...prev,
//                                         [name]: value,
//                                         errorStatus: {
//                                             ...prev.errorStatus,
//                                             [name]: true,
//                                         },
//                                         errorFields: {
//                                             ...prev.errorFields,
//                                             [name]: "Password is Required",
//                                         },
//                                     }));
//                                 }
//                                 else {
//                                     setState((prev) => ({
//                                         ...prev,
//                                         [name]: value,
//                                         errorStatus: {
//                                             ...prev.errorStatus,
//                                             [name]: false,
//                                         },
//                                         errorFields: {
//                                             ...prev.errorFields,
//                                             [name]: "",
//                                         },
//                                     }));
//                                 }
//                             }}
//                             state={state}
//                             icon={
//                                 <Lock
//                                     sx={{
//                                         color:
//                                             state.errorStatus.Password === true
//                                                 ? "danger.main"
//                                                 : "#8a8787",
//                                     }}
//                                     className="icon"
//                                 />
//                             }
//                             Icon={
//                                 <span
//                                     onClick={() => {
//                                         if (!showPassword) {
//                                             setShowPassword(true);
//                                         } else {
//                                             setShowPassword(false);
//                                         }
//                                     }}
//                                 >
//                                     {showPassword ? (
//                                         <VisibilityOff
//                                             sx={{
//                                                 color:
//                                                     state.errorStatus.Password === true
//                                                         ? "danger.main"
//                                                         : "#8a8787",
//                                             }}
//                                             className="iconpassword"
//                                         />
//                                     ) : (
//                                         <Visibility
//                                             sx={{
//                                                 color:
//                                                     state.errorStatus.Password === true
//                                                         ? "danger.main"
//                                                         : "#8a8787",
//                                             }}
//                                             className="iconpassword"
//                                         />
//                                     )}
//                                 </span>
//                             }
//                         />
//                         <Grid container>
//                             <Grid item xs>
//                                 <FormControlLabel
//                                     control={<Checkbox value="remember" color="primary" />}
//                                     label={<Box sx={{ fontSize: "15px", color: "#75428C" }}>Remember Me</Box>}
//                                 />
//                             </Grid>
//                             <Grid item xs sx={{ display: 'flex', alignItems: "center", justifyContent: "end" }}>
//                                 <Link variant="body2"
//                                     onClick={handleForgetPasswordClick}
//                                 >
//                                     Forgot password?
//                                 </Link>
//                             </Grid>
//                         </Grid>

//                         <LoadingButton
//                             style={{
//                                 width: "100%",
//                                 height: "40px",
//                                 background: "#75428C",
//                                 borderRadius: "5px",
//                             }}
//                             loading={loading}
//                             disableRipple={true}
//                             variant="contained"
//                             onClick={(event) => {
//                                 handleSubmit(event);
//                             }}
//                         >
//                             Sign In
//                         </LoadingButton>
//                         <Grid item>
//                             <Link href="#" variant="body2">
//                                 {"Don't have an account? Sign Up"}
//                             </Link>
//                         </Grid>
//                     </form>
//                 </Box>
//             </Grid>
//         </Container>
//     );
// }

import React, { useCallback, useState } from 'react';
import { Grid, Box, TextField, Button, Checkbox, FormControlLabel, Typography, Paper } from '@mui/material';
import CustomInputBox from '../../components/customInputBox/CustomInputBox';
import { Email, Lock, Visibility, VisibilityOff } from '@mui/icons-material';
import { useDebounce } from '../../hooks/useDebounce';

const LoginForm = () => {
    return (
        <Grid container component={Paper} elevation={6} square>
            <div className="form-container sign-up-container">
                <form action="#">
                    <h1>Create Account</h1>
                    <div className="social-container">
                        <a href="#" className="social"><i className="fab fa-facebook-f"></i></a>
                        <a href="#" className="social"><i className="fab fa-google-plus-g"></i></a>
                        <a href="#" className="social"><i className="fab fa-linkedin-in"></i></a>
                    </div>
                    <span>or use your email for registration</span>
                    <input type="text" placeholder="Name" />
                    <input type="email" placeholder="Email" />
                    <input type="password" placeholder="Password" />
                    <button>Sign Up</button>
                </form>
            </div>
        </Grid>
    );
};

export default LoginForm;

